/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({ alwaysOn }) => (
  <div
    className={`absolute inset-0 bg-gradient-to-b from-hoverShade to-transparent ${!alwaysOn &&
      'transition-opacity duration-200 opacity-0 group-hover:opacity-100'}`}
  />
);

Overlay.propTypes = {
  alwaysOn: PropTypes.bool,
};

Overlay.defaultProps = {
  alwaysOn: false,
};

export default Overlay;
